// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { attributesStyles } from "@eisinc/Overrides/Widgets/ProductDetails/ProductDetailsAttributes";
import { fontConfig } from "@eisinc/XDL/PreStyle/typography";
import { color, xScreen } from "@eisinc/XDL/Utilities";
import { css } from "styled-components";


attributesStyles.attributeTypeLabelText = {
    variant: "h4",
    forwardAs: "p",
    css: css`
        margin-bottom: 0;
    `,
};

attributesStyles.table = {
    css: css`
        &&& tr {
            background-color: ${color("common.white")};
        }
    `,
};

attributesStyles.labelCell = {
    css: css`
        text-wrap: wrap;
        width: 209px;
        vertical-align: baseline;
        padding: 12px 10px 12px 0px;
        border-bottom: 1px solid ${color("common.border")};
        ${xScreen("lte", "md")} {
            width: 242px;
        }
        ${xScreen("lte", "sm")} {
            padding-right: 8px;
        }
        @media print {
            min-width: 204px;
            max-width: 204px;
        }
    `,
};

attributesStyles.valueCell = {
    css: css`
        text-wrap: wrap;
        padding: 12px 0px 12px 10px;
        border-bottom: 1px solid ${color("common.border")};
        vertical-align: baseline;
        ${xScreen("lte", "sm")} {
            width: 50%;
            padding-left: 8px;
        }
    `,
};

attributesStyles.label = {
    weight: fontConfig.weight.medium,
    size: fontConfig.small.size,
    lineHeight: fontConfig.xSmall.lineHeight,
};

attributesStyles.value = {
    weight: fontConfig.weight.regular,
    size: fontConfig.small.size,
    lineHeight: fontConfig.xSmall.lineHeight,
};

attributesStyles.accordion = {
    panelProps: {
        css: css`
            padding-bottom: 0;
        `,
    }
}
